(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("angular-barcode-scanner", [], factory);
	else if(typeof exports === 'object')
		exports["angular-barcode-scanner"] = factory();
	else
		root["angular-barcode-scanner"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _barcodeScanner = __webpack_require__(1);
	
	var _barcodeScanner2 = _interopRequireDefault(_barcodeScanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barcodeScanner = angular.module('barcodeScanner', []);
	
	barcodeScanner.directive('barcodeScanner', _barcodeScanner2.default);
	
	exports.default = barcodeScanner;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$window", function ($window) {
	    'ngInject';
	
	    return {
	        restrict: 'AE',
	        scope: {
	            separatorChar: '=',
	            triggerChar: '=',
	            scanCallback: '=',
	            triggerCallback: '='
	        },
	        link: function link(scope) {
	            var buffer = '';
	            angular.element($window).on('keypress', function (e) {
	                var keycode = e.keyCode ? e.keyCode : e.which;
	                var triggerChar = parseInt(scope.triggerChar, 10);
	                var separatorChar = parseInt(scope.separatorChar, 10);
	
	                if (keycode === triggerChar) {
	                    if (typeof scope.triggerCallback !== 'undefined') {
	                        scope.triggerCallback();
	                        e.preventDefault();
	                    }
	                } else {
	                    var valid = keycode >= 32 && keycode <= 255;
	                    if (valid === true && keycode !== separatorChar) {
	                        buffer += String.fromCharCode(keycode);
	                    } else if (keycode === separatorChar) {
	                        if (buffer.length > 0) {
	                            scope.scanCallback(buffer);
	                        }
	                        buffer = '';
	                    }
	                }
	            });
	        }
	    };
	}];
	
	module.exports = exports['default'];

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// angular-barcode-scanner.js